// import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { slideDownUp } from '../shared/animations';
import { UserData } from '../interfaces/users.interface';
import { UsersService } from '../services/users/users.service';
import { map, Observable } from 'rxjs';
import { selectCurrentUser } from '../services/users/user.selectors';

@Component({
    moduleId: module.id,
    selector: 'sidebar',
    templateUrl: './sidebar.html',
    animations: [slideDownUp],
})
export class SidebarComponent implements OnInit {
    userData$!: Observable<UserData | null>;
    isAdmin$!: Observable<boolean>;
    isMerchant$!: Observable<boolean>;
    hasAccess$!: Observable<boolean>;
    active = false;
    store: any;
    activeDropdown: string[] = [];
    parentDropdown: string = '';
    constructor(
      public translate: TranslateService,
      public storeData: Store<any>,
      public router: Router,
    ) {
        this.initStore().then();
    }
    async initStore() {
        this.storeData
            .select((d) => d.index)
            .subscribe((d) => {
                this.store = d;
            });
    }

    ngOnInit() {
        this.setActiveDropdown();
        this.userData$ = this.storeData.select(selectCurrentUser);

        this.isAdmin$ = this.userData$.pipe(
          map((user) => user?.roles?.some((role) => role.code === 'admin') ?? false)
        );

        this.isMerchant$ = this.userData$.pipe(
          map((user) => user?.roles?.some((role) => role.code === 'merchant') ?? false)
        );

        this.hasAccess$ = this.userData$.pipe(
          map(user =>
            user?.roles?.some(role => role.code === 'admin' || role.code === 'merchant') ?? false
          )
        );
    }

    setActiveDropdown() {
        const selector = document.querySelector('.sidebar ul a[routerLink="' + window.location.pathname + '"]');
        if (selector) {
            selector.classList.add('active');
            const ul: any = selector.closest('ul.sub-menu');
            if (ul) {
                let ele: any = ul.closest('li.menu').querySelectorAll('.nav-link') || [];
                if (ele.length) {
                    ele = ele[0];
                    setTimeout(() => {
                        ele.click();
                    });
                }
            }
        }
    }

    toggleMobileMenu() {
        if (window.innerWidth < 1024) {
            this.storeData.dispatch({ type: 'toggleSidebar' });
        }
    }

    toggleAccordion(name: string, parent?: string) {
        if (this.activeDropdown.includes(name)) {
            this.activeDropdown = this.activeDropdown.filter((d) => d !== name);
        } else {
            this.activeDropdown.push(name);
        }
    }

    // private async getUserData(): Promise<void> {
    //   try {
    //     const { data } = await firstValueFrom(this.userService.getMe());
    //     this.userData = data;
    //     if (this.userData?.roles?.length > 0) {
    //       this.isAdmin = this.userData.roles.some((role) => role.code === 'admin');
    //       if (!this.isAdmin) {
    //         this.isMerchant = this.userData.roles.some((role) => role.code === 'merchant');
    //       }
    //       // this.userData.roles = this.userData.roles.filter((role) => role.code !== 'superadmin');
    //     }
    //   } catch (error) {
    //     showNotification('error', 'Failed to fetch user', JSON.stringify(error));
    //   }
    // }
}
